import 'bootstrap/dist/js/bootstrap.bundle';
